import svgCheckCircle from '@tmorrow/cre8-wc/icons/Check_Filled.svg?raw';
import svgErrorFilled from '@tmorrow/cre8-wc/icons/Error_Filled.svg?raw';
import { html,  } from 'lit';
import { property } from 'lit/decorators.js';
import { Cre8Element } from '../cre8-element';
import '../icon/icon';
import styles from './field-note.styles.js';

/**
 * Field Note gives direction on how to fill out a form field and to alert users of form errors and successes.
 * It’s used below an input field and never on its own.
 * @slot - The note content
 */

export class Cre8FieldNote extends Cre8Element {
    static styles = [styles];

  /**
   * Changes the component's treatment to represent an error
   *  @attr {boolean}
   */
  @property({ type: Boolean, reflect: true })
      isError?: boolean;

  /**
   * Changes the component's treatment to represent a success
   *  @attr {boolean}
   */
  @property({ type: Boolean, reflect: true })
      isSuccess?: boolean;

  /**
   *  DEPRECATED: Icon name used for the icon before to the field note
   * @deprecated
   */
  @property()
      iconName?: string;

  /**
   * Check if there are success or error states and set "aria-live=polite"
   */
  fieldNoteAriaLive(): 'polite' | 'off' | 'assertive' {
      if (this.isError || this.isSuccess) {
          return 'polite';
      }
      return null;
  }

  render() {
      const componentClassName = this.componentClassNames('cre8-c-field-note', {
          'cre8-is-error': this.isError,
          'cre8-is-success': this.isSuccess,
      });

      return html`
        <div
          aria-live="${this.fieldNoteAriaLive() ?? 'off'}"
          class="${componentClassName}">
        ${this.isError === true
        ? html`<cre8-icon class="cre8-field-note-icon" svg='${svgErrorFilled}' aria-hidden="true" ></cre8-icon>`
        : ''
}
            ${this.isSuccess === true
        ? html`<cre8-icon class="cre8-field-note-icon" svg='${svgCheckCircle}' aria-hidden="true"></cre8-icon>`
        : ''
}
          <div><slot></slot></div>
        </div>
    `;
  }
}

if (customElements.get('cre8-field-note') === undefined) {
    customElements.define('cre8-field-note', Cre8FieldNote);
}

declare global {
  interface HTMLElementTagNameMap {
    'cre8-field-note': Cre8FieldNote;
  }
}

export default Cre8FieldNote;
